import { LayoutContainer } from '../../containers/advancedFilters/LayoutContainer';
import { IFilter } from '../../types/advancedFilters';

export const layout: IFilter = {
  component: LayoutContainer,
};
